/* eslint-disable no-unused-vars */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  errors: {
    Name: null,
    EmailID: null,
    Subject: null,
    Message: null,
  },
  credentials: {
    Name: null,
    EmailID: null,
    Subject: null,
    Message: null,
  },
  message: {
    status: null,
    message: null,
  },
  data: {

  },
};

const contactReducer = createReducer(initialState, {
  [types.SEND_CONTACT_FORM](state, action) {
    return {
      ...state,
      credentials: {
        ...action.data,
      },
    };
  },
  [types.CONTACT_FIELD_CHANGE](state, payload) {
    return {
      ...state,
      credentials: Object.assign({}, state.credentials, { [payload.field]: payload.value }),
      message: {
        message: null,
      },
    };
  },
  [types.CONTACT_ERRORS_CHANGE](state, payload) {
    return {
      ...state,
      errors: Object.assign({}, state.errors, { [payload.field]: payload.error })
    };
  },
  [types.SET_MESSAGE](state, action) {
    return {
      ...state,
      message: action.message,
    };
  },
  [types.RESET_FORM](state, action) {
    return {
      ...initialState,
    };
  },
  [types.CONTACT_REQUEST_PAGE_DATA](state, action) {
    return {
      ...state,
    };
  },
  [types.CONTACT_REQUEST_PAGE_DATA_SUCCESS](state, action) {
    return {
      ...state,
      data: {
        ...action.data,
      },
    };
  },
});

export default contactReducer;
